<template>
  <div class="acomodar">
    <LineasTelefonicas/>
  </div>
</template>

<script>
import LineasTelefonicas from '@/components/ModTecnologia/LineasTelefonicas/LineasTelefonicas.vue';
export default {
  name: 'CopiasLineasTelefonicas',
  components: {
    LineasTelefonicas
  },

  data() {
    return {
      
    };
  },

  mounted() {
    
  },
  created(){
    this.cambiarEstadoNavbar()
  },

   methods: {
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },
  },
};
</script>
